export default __webpack_public_path__ + "static/media/HP-D5-EV.e83a6661.png";